
const privacyBody = `**1. Responsable del tratamiento / Verantwortlicher**

[COMPLETAR: Nombre completo del titular o razón social]
[COMPLETAR: Dirección completa]
E-Mail: bringylatam@gmail.com

**2. Datos que recopilamos**

Cuando utilizás el formulario de contacto de este sitio, recopilamos los siguientes datos: nombre, dirección de correo electrónico, ruta de interés y el mensaje que nos enviás. Estos datos son necesarios para poder responderte.

El sitio web puede almacenar cookies técnicas estrictamente necesarias para el funcionamiento básico. No utilizamos cookies de rastreo ni publicidad de terceros.

**3. Finalidad del tratamiento**

Los datos del formulario se utilizan exclusivamente para responder a tu consulta y gestionar tu registro inicial en la plataforma. No son cedidos a terceros sin tu consentimiento, salvo obligación legal.

**4. Base jurídica**

El tratamiento se basa en tu consentimiento (Art. 6 (1)(a) RGPD) al enviar el formulario, y en el interés legítimo de gestionar la relación precontractual (Art. 6 (1)(b) RGPD).

**5. Conservación de datos**

Los datos del formulario de contacto se conservan durante el tiempo necesario para gestionar tu solicitud y, como máximo, 12 meses desde el último contacto, salvo que la relación contractual posterior exija un período más largo.

**6. Tus derechos**

Tenés derecho a: acceder a tus datos personales, solicitar su rectificación o supresión, oponerte al tratamiento, solicitar la portabilidad de tus datos, y presentar una reclamación ante la autoridad de protección de datos competente.

Para ejercer tus derechos, escribinos a: bringylatam@gmail.com

**7. Hosting**

Este sitio está alojado en Cloudflare. Cloudflare puede procesar datos técnicos de acceso (dirección IP, navegador, fecha y hora) como parte de su servicio de red y seguridad. Para más información: https://www.cloudflare.com/privacypolicy/

**8. Cambios en esta política**

Podemos actualizar esta política en cualquier momento. La versión vigente estará siempre disponible en esta página con la fecha de última actualización.`

const impressumBody = `Angaben gemäß § 5 TMG / Información según § 5 TMG

**Verantwortlich / Responsable:**
[COMPLETAR: Nombre completo del titular o razón social]
[COMPLETAR: Dirección completa — calle, número, código postal, ciudad, país]

**Kontakt / Contacto:**
E-Mail: bringylatam@gmail.com
Telefon / Teléfono: [COMPLETAR: +49 ... o número correspondiente]

**Plattformbetreiber / Operador de la plataforma:**
Bringy
[COMPLETAR: misma dirección legal]

**Umsatzsteuer-ID / NIF-IVA (si aplica):**
[COMPLETAR: DE... o número fiscal del país de registro]

**Haftungshinweis / Aviso de responsabilidad:**
Bringy actúa como plataforma intermediaria entre compradores y viajeros. No somos parte contratante en las transacciones entre usuarios y no asumimos responsabilidad por los productos intercambiados, salvo en los casos expresamente contemplados en nuestras Condiciones de Uso.

La información de este sitio se ha preparado con cuidado; no obstante, no garantizamos su exactitud, integridad o actualización.

**Resolución de conflictos:**
La Comisión Europea pone a disposición una plataforma de resolución de litigios en línea: https://ec.europa.eu/consumers/odr
No estamos dispuestos ni obligados a participar en procedimientos de resolución de conflictos ante un organismo de arbitraje de consumo.`

export const es = {
  brand: {
    name: 'Bringy',
    tagline: 'Personas reales. Productos reales. Rutas verificadas.',
  },
  nav: {
    howItWorks: 'Cómo funciona',
    whyUs: 'Por qué Bringy',
    offerings: 'Servicios',
    faq: 'FAQ',
    contact: 'Contacto',
    cta: 'Comenzar',
  },
  hero: {
    eyebrow: 'Europa ↔ Sudamérica',
    titleAccent: 'Bring',
    titleRest: 'Lo que importa.',
    subtitle:
      'Conectamos personas que viajan entre Europa y Sudamérica con quienes necesitan productos del otro lado. Sin courier, sin agencia — solo personas reales con identidad verificada.',
    ctaBuscar: 'Buscar un producto',
    ctaOfrecer: 'Ofrecer como viajero',
    trustBadges: [
      { label: 'Identidad verificada' },
      { label: 'Pago en escrow' },
      { label: 'Puntuación pública del viajero' },
      { label: 'Entrega documentada' },
    ],
    boardingPass: {
      passengerLabel: 'PASAJERO',
      brand: 'BRINGY',
      sub: 'ENVÍO · VERIFICADO · ASEGURADO',
      fromCode: 'BER',
      fromCity: 'BERLIN',
      toCode: 'EZE',
      toCity: 'BUENOS AIRES',
      flight: 'VUELO BR · 2026',
      gate: 'PUERTA A7',
    },
    coordsBerlin: '52.52°N · 13.40°E',
    coordsBuenosAires: '34.60°S · 58.38°W',
  },
  launchTrust: {
    id: 'lanzamiento',
    launchNote:
      'Bringy está en fase de lanzamiento. Cada nuevo viajero es verificado personalmente por nuestro equipo.',
    processTitle: 'Antes de que un viajero lleve un solo ítem',
    processIntro:
      'Mostramos el rigor del proceso — no testimonios inventados. Así construimos confianza desde el día uno.',
    stepVerified: 'Verificado',
    stepPending: 'Pendiente',
    processSteps: [
      {
        number: '01',
        title: 'Verificación de identidad',
        description: 'Documento oficial validado antes de operar en la plataforma.',
        icon: 'shield',
        verified: 'yes',
      },
      {
        number: '02',
        title: 'Onboarding por videollamada',
        description: 'Conversación inicial con nuestro equipo para explicar reglas y expectativas.',
        icon: 'video',
        verified: 'yes',
      },
      {
        number: '03',
        title: 'Acuerdo de escrow',
        description: 'Aceptación de términos de pago protegido antes de la primera transacción.',
        icon: 'lock',
        verified: 'yes',
      },
    ],
    foundingMembers: '{count} viajeros ya registraron su primera ruta',
  },
  whyUs: {
    id: 'por-que',
    sectionLabel: '02 · Por qué Bringy',
    headline: 'Cuatro garantías.',
    headlineAccent: 'Sin excepciones.',
    title: 'Por qué Bringy funciona',
    subtitle:
      'Las soluciones informales existen — los grupos de WhatsApp, los contactos de contactos. Bringy hace lo mismo, con la infraestructura que le faltaba.',
    cardAirline: 'BR · 2026',
    cardConfirmed: 'CONFIRMADO',
    cardPending: 'PENDIENTE',
    cardApproved: '· APROBADO ·',
    cardsMeta: [
      { value: 'IDENTIDAD', field: 'KYC · PASAPORTE' },
      { value: 'SEGURO', field: 'HASTA €4.000' },
      { value: 'CUMPLIMIENTO', field: 'EU · AR · DECLARADO' },
      { value: 'ENTREGA', field: 'FOTO · RASTREADO' },
    ],
    items: [
      {
        title: 'Confianza verificada',
        description:
          'Cada viajero pasa por verificación de identidad antes de operar en la plataforma. Sabés con quién estás tratando.',
        icon: 'shield',
        verified: 'yes',
        badgeValue: 'IDENTIDAD',
        badgeField: 'KYC · PASAPORTE',
      },
      {
        title: 'Tu dinero, protegido',
        description:
          'Los fondos quedan en escrow hasta que confirmás la recepción del producto. No hay riesgo de pagar por algo que no llega.',
        icon: 'lock',
        verified: 'yes',
        badgeValue: 'SEGURO',
        badgeField: 'HASTA €4.000',
      },
      {
        title: 'Reputación real',
        description:
          'Cada viajero acumula historial de entregas y calificaciones. Podés ver su puntuación antes de coordinar.',
        icon: 'star',
        verified: 'yes',
        badgeValue: 'CUMPLIMIENTO',
        badgeField: 'EU · AR · DECLARADO',
      },
      {
        title: 'Entrega documentada',
        description:
          'Para mayor seguridad, ofrecemos verificación en vivo con un representante de Bringy por videollamada.',
        icon: 'video',
        verified: 'yes',
        badgeValue: 'ENTREGA',
        badgeField: 'FOTO · RASTREADO',
      },
    ],
  },
  services: {
    id: 'como-funciona',
    sectionLabel: '03 · Cómo funciona',
    headline: 'Una pista, no',
    headlineAccent: 'un proceso.',
    tagline: 'Cuatro pasos. Un cruce del Atlántico.',
    title: 'Cómo funciona',
    subtitle: '',
    footerLabels: { status: 'ESTADO', eta: 'ETA', lane: 'CARRIL' },
    stepMeta: [
      { status: 'EN ESPERA', eta: '~ 18H', lane: 'A7' },
      { status: 'EN ESPERA', eta: '~ 36H', lane: 'B8' },
      { status: 'EN ESPERA', eta: '~ 54H', lane: 'C9' },
      { status: 'EN ESPERA', eta: '~ 72H', lane: 'D10' },
    ],
    steps: [
      {
        number: 1,
        title: 'Publicá tu pedido',
        description:
          'Describí el producto que necesitás, el destino y lo que ofrecés por el servicio de traslado.',
      },
      {
        number: 2,
        title: 'Un viajero acepta',
        description:
          'Viajeros verificados con rutas activas ven tu pedido y se ofrecen a llevarlo en su próximo viaje.',
      },
      {
        number: 3,
        title: 'Coordinan los detalles',
        description:
          'Acordás la forma de pago, el punto de entrega y los tiempos directamente con el viajero por el chat de la plataforma.',
      },
      {
        number: 4,
        title: 'Recibís y confirmás',
        description:
          'Una vez que tenés el producto, confirmás la entrega y el pago se libera al viajero.',
      },
    ],
  },
  manifest: {
    sectionLabel: '04 · Manifiesto de hoy',
    headline: 'El panel,',
    headlineAccent: 'en vivo.',
    tagline: 'Todos los envíos declarados.',
    liveLabel: 'En vivo · {count} envíos hoy',
    columns: ['Hora', 'Desde → Hasta', 'Envío', 'Estado', 'Puerta'],
    rows: [
      { time: '02:14', from: 'BER', to: 'EZE', carry: 'MEDICACIÓN', status: 'ASEGURADO', gate: 'A07', statusKey: 'insured' },
      { time: '06:40', from: 'MAD', to: 'EZE', carry: 'ELECTRÓNICA', status: 'VERIFICADO', gate: 'B12', statusKey: 'verified' },
      { time: '09:25', from: 'FCO', to: 'EZE', carry: 'CALZADO', status: 'EMBARQUE', gate: 'C04', statusKey: 'boarding' },
      { time: '11:55', from: 'CDG', to: 'EZE', carry: 'DOCUMENTOS', status: 'ASEGURADO', gate: 'D21', statusKey: 'insured' },
      { time: '14:30', from: 'LIS', to: 'EZE', carry: 'LIBROS', status: 'EMPAREJADO', gate: 'A03', statusKey: 'matched' },
    ],
    footerLeft: 'EU → AR · Manifiesto 2026',
    footerRight: 'Pre-lanzamiento · Rutas verificadas',
  },
  activeRoutes: {
    sectionLabel: '05 · Rutas activas',
    headline: 'Europa parte.',
    headlineAccent: 'Buenos Aires espera.',
    tagline: 'Cinco corredores. Una dirección. Solo llevamos lo que alguien ya está volando.',
    routePrefix: 'RUTA',
    originLabel: 'Origen',
    destLabel: 'Destino',
    flightLabel: 'Vuelo',
    openLabel: 'Abierto',
    routes: [
      { fromCity: 'Berlín',  fromCode: 'BER', toCity: 'Buenos Aires', toCode: 'EZE', duration: '~ 14h' },
      { fromCity: 'Madrid',  fromCode: 'MAD', toCity: 'Buenos Aires', toCode: 'EZE', duration: '~ 13h' },
      { fromCity: 'Roma',    fromCode: 'FCO', toCity: 'Buenos Aires', toCode: 'EZE', duration: '~ 14h' },
      { fromCity: 'París',   fromCode: 'CDG', toCity: 'Buenos Aires', toCode: 'EZE', duration: '~ 13h 30m' },
      { fromCity: 'Lisboa',  fromCode: 'LIS', toCity: 'Buenos Aires', toCode: 'EZE', duration: '~ 12h 20m' },
    ],
  },
  offerings: {
    id: 'servicios',
    sectionLabel: '06 · Servicios',
    title: 'Servicios',
    buyer: {
      label: 'Para compradores',
      title: 'Encontrá lo que no llega a tu país',
      body: 'Publicá lo que necesitás y conectate con un viajero verificado que ya está haciendo el viaje. Accedé a productos con precios de origen, sin intermediarios.',
      cta: 'Publicar un pedido',
      products: [
        { name: 'iPhone 17 Pro · 256GB', price: '€ 980', route: 'Madrid → Buenos Aires', image: 'products/iPhone_17_Pro_Cosmic_Orange_PDP_Image_Position_1__DEDE-l.webp', imageAlt: 'iPhone 17 Pro' },
        { name: 'Nike Air Max 90', price: '€ 140', route: 'Berlín → Buenos Aires', image: 'products/nike.webp', imageAlt: 'Nike Air Max 90' },
        { name: 'PlayStation 5 Slim', price: '€ 480', route: 'Roma → Buenos Aires', image: 'products/sony-playstation-5-digital-edition-825-gb-wlan-schwarz-weiss.webp', imageAlt: 'PlayStation 5 Slim' },
        { name: 'Chanel Nº5 · 100ml', price: '€ 120', route: 'París → Buenos Aires', image: 'products/chanel-no-5-edp-vapo-200ml.png', imageAlt: 'Chanel Nº5' },
      ],
    },
    traveler: {
      label: 'Para viajeros',
      title: 'Monetizá el espacio libre de tu equipaje',
      body: '¿Viajás entre Europa y Sudamérica? Publicá tu ruta y los productos que podés llevar. Amortizá parte del viaje y construí reputación como viajero de confianza.',
      cta: 'Registrarme como viajero',
      routes: [
        { route: 'Berlín → Buenos Aires', activeTravelers: 'HQ · 3 viajeros activos' },
        { route: 'Madrid → Buenos Aires', activeTravelers: '12 viajeros activos' },
        { route: 'Roma → Buenos Aires', activeTravelers: '5 viajeros activos' },
        { route: 'París → Buenos Aires', activeTravelers: '4 viajeros activos' },
        { route: 'Lisboa → Buenos Aires', activeTravelers: '7 viajeros activos' },
      ],
    },
  },
  faq: {
    id: 'faq',
    title: 'Preguntas frecuentes',
    subtitle: '',
    items: [
      {
        question: '¿Cómo me registro en Bringy?',
        answer:
          'Completá el formulario con tu nombre, email y si querés comprar o viajar. Te contactamos en 24 horas para guiarte en los primeros pasos.',
      },
      {
        question: '¿Quién puede ser viajero?',
        answer:
          'Cualquier persona mayor de 18 años que viaje regularmente entre Europa y Sudamérica. Se requiere verificación de identidad antes de publicar rutas activas.',
      },
      {
        question: '¿Cómo sé que el viajero es de confianza?',
        answer:
          'Cada viajero tiene un perfil con su nivel de verificación, historial de entregas y calificaciones de otros usuarios. A mayor historial, mayor confianza.',
      },
      {
        question: '¿Qué pasa con mi dinero si el producto no llega?',
        answer:
          'Los fondos se mantienen en escrow hasta que confirmás la recepción. Si hay un problema, el equipo de Bringy interviene y media entre las partes.',
      },
      {
        question: '¿Qué productos se pueden pedir?',
        answer:
          'Cualquier producto legal que pueda transportarse en equipaje de cabina o bodega según las regulaciones aduaneras del país de destino. Electrónica, ropa, cosmética, alimentos no perecederos, documentos, entre otros.',
      },
      {
        question: '¿Cuánto cobra Bringy?',
        answer:
          'Una comisión del 8 al 10% sobre cada transacción exitosa. Los viajeros frecuentes pueden acceder a la suscripción Pro por € 9/mes, que elimina la comisión y ofrece visibilidad adicional.',
      },
      {
        question: '¿Puedo pedir una entrega con verificación en vivo?',
        answer:
          'Sí. Para transacciones de mayor valor o cuando ambas partes lo prefieran, un representante de Bringy se une por videollamada, verifica las identidades y documenta el intercambio.',
      },
      {
        question: '¿En qué rutas están disponibles?',
        answer:
          'Operamos rutas desde Berlín (HQ), Madrid, Roma, París y Lisboa — todas con destino Buenos Aires. Sumamos nuevas rutas según la demanda de la comunidad.',
      },
      {
        question: '¿Qué medios de pago aceptan?',
        answer:
          'Tarjetas Visa, Mastercard y Amex. Stripe para pagos internacionales con tarjeta desde cualquier país. Transferencias SEPA en Europa. Mercado Pago en Sudamérica. Los fondos se liberan en 1–2 días hábiles tras confirmar la entrega.',
      },
    ],
  },
  globe: {
    cities: ['Berlín ★', 'Madrid', 'Roma', 'París', 'Lisboa', 'Buenos Aires'],
  },
  contact: {
    id: 'contacto',
    title: '¿Tenés una pregunta o querés unirte?',
    subtitle:
      'Estamos en la etapa de lanzamiento y nos interesa conocer tu caso. Completá el formulario y un miembro del equipo se pone en contacto con vos en las próximas 24 horas.',
    emailLabel: 'También podés escribirnos a',
  },
  footer: {
    copyright: '© {year} Bringy. Todos los derechos reservados.',
    tagline: 'Personas reales. Productos reales. Rutas verificadas.',
    hubBerlin: 'Berlín',
    hubBuenosAires: 'Buenos Aires',
    links: {
      howItWorks: 'Cómo funciona',
      whyUs: 'Por qué Bringy',
      offerings: 'Servicios',
      faq: 'Preguntas frecuentes',
      contact: 'Contacto',
      impressum: 'Impressum',
      privacy: 'Política de privacidad',
    },
    social: {
      instagram: '@bringy',
      linkedin: 'linkedin.com/company/bringy',
      linkedinLabel: 'LinkedIn',
    },
    credits: {
      prefix: 'Hecho por',
      studio: 'INKSKY independent studio',
    },
  },
  legal: {
    backHome: 'Volver al inicio',
    placeholderNotice: 'Campos marcados [COMPLETAR] pendientes de constitución de entidad legal.',
    privacy: {
      title: 'Política de privacidad',
      body: privacyBody,
    },
    terms: {
      title: 'Condiciones de uso',
      body: 'Bringy actúa como plataforma intermediaria entre compradores y viajeros. El uso implica aceptación de verificación de identidad, transporte solo de productos legales y resolución de disputas según las condiciones de la plataforma. Texto definitivo pendiente de publicación.',
    },
    impressum: {
      title: 'Impressum',
      body: impressumBody,
    },
  },
  a11y: {
    openMenu: 'Abrir menú',
    closeMenu: 'Cerrar menú',
    chooseLanguage: 'Elegir idioma',
  },
  forms: {
    backHome: 'Volver al inicio',
    submit: 'Enviar solicitud',
    successTitle: '¡Recibimos tu solicitud!',
    successBody:
      'Nos ponemos en contacto en las próximas 24 horas para coordinar los detalles. Bienvenido/a a Bringy.',
    fields: {
      name: { label: 'Nombre completo', placeholder: 'Tu nombre completo' },
      email: { label: 'Email', placeholder: 'tu@email.com' },
      role: {
        label: 'Yo soy...',
        placeholder: 'Seleccioná una opción',
        buyer: 'Comprador',
        traveler: 'Viajero',
      },
      countryRoute: {
        label: 'Ruta de interés',
        placeholder: 'Ej: Madrid → Buenos Aires',
        other: 'Otra ruta',
      },
      message: {
        label: 'Producto o mensaje',
        placeholder: 'Contanos qué producto buscás o qué podés llevar',
        optional: 'Opcional',
      },
    },
    errors: {
      required: 'Completá este campo',
      email: 'Ingresá un email válido',
      role: 'Seleccioná una opción',
      submitFailed: 'No pudimos enviar el formulario. Intentá de nuevo.',
    },
    sending: 'Enviando…',
    privacyNote:
      'Al enviar aceptás que usemos estos datos para contactarte sobre Bringy. Ver nuestra',
    defaultDescriptions: {
      requestItem: 'Consulta desde formulario de contacto',
      becomeTraveler: 'Registro de viajero desde formulario de contacto',
    },
    requestItem: {
      title: 'Buscar un producto',
      subtitle: 'Contanos qué necesitás y te contactamos en 24 horas.',
    },
    becomeTraveler: {
      title: 'Ofrecer como viajero',
      subtitle: 'Contanos tu ruta y te contactamos en 24 horas.',
    },
  },
}
